const StepPlaceholder = () => (
  <div>
    <h3>Placeholder Step</h3>
  </div>
)

export default StepPlaceholder
